import React from 'react';
import styled from '@emotion/styled';
import { i18n } from 'src/common';
import { colors } from 'src/theme';
import { Flex } from '../../grid';
import { KPICard, KPIContainer } from './kpi.card';

const KPISectionStyle = styled(Flex)({
  position: 'relative',
  left: '50%',
  transform: 'translateX(-50%)',
  width: '100vw',
  maxWidth: '100vw',
  backgroundColor: colors.white,
  marginTop: 15,
  marginBottom: 0,
  boxSizing: 'border-box',
  flexDirection: 'column',
  flexShrink: 0,
  alignItems: 'center',

  '@media (max-width: 575px)': {
    width: 'auto',
    left: 0,
    transform: 'none',
    marginLeft: '-7%',
    marginRight: '-7%',
  },
});

export const AdditionalKpiInfoCard = () => (
  <KPISectionStyle>
    <KPIContainer>
      <KPICard
        number="1."
        title={i18n.t('pages.customerOnlyDate.kpi.speed.title')}
        description={i18n.t('pages.customerOnlyDate.kpi.speed.description')}
      />
      <KPICard
        number="2."
        title={i18n.t('pages.customerOnlyDate.kpi.quality.title')}
        description={i18n.t('pages.customerOnlyDate.kpi.quality.description')}
      />
      <KPICard
        number="3."
        title={i18n.t('pages.customerOnlyDate.kpi.care.title')}
        description={i18n.t('pages.customerOnlyDate.kpi.care.description')}
      />
    </KPIContainer>
  </KPISectionStyle>
);
